import * as React from "react";
import { Avatar, Button, IconButton } from "../mui";
import { SettingsRoundedIcon, LogoutRoundedIcon, MenuRoundedIcon } from "../icons";

import "../../styles/components/topnav.css";
import avatarImage from "../../images/img-avatar.jpg";

function getInitials(name) {
  return name
    .split(" ")
    .filter(Boolean)
    .map((part) => part[0])
    .join("")
    .slice(0, 2);
}

export default function TopNav({ employeeName, employeeId, onLogout, onMenuClick }) {
  return (
    <div className="app-topnav">
      <div className="app-topnav-left">
        <IconButton 
          className="app-topnav-menu-button"
          onClick={onMenuClick}
          aria-label="Open menu"
        >
          <MenuRoundedIcon />
        </IconButton>
      </div>

      <div className="app-topnav-right">
        <div className="app-topnav-profile">
          <Avatar
            className="app-topnav-avatar"
            alt={employeeName}
            src={avatarImage}
          >
            {getInitials(employeeName)}
          </Avatar>
          <div className="app-topnav-info">
            <span className="app-topnav-name">Welcome Back, {employeeName}</span>
            <span className="app-topnav-id">{employeeId}</span>
          </div>
        </div>

        <div className="app-topnav-actions">
          <Button
            variant="text"
            className="app-topnav-settings"
            component="a"
            href="#admin-settings"
            startIcon={<SettingsRoundedIcon />}
            aria-label="Admin Settings"
          >
            <span className="app-topnav-settings-text">Admin Settings</span>
          </Button>
          <Button
            variant="text"
            className="app-topnav-logout"
            onClick={onLogout}
            startIcon={<LogoutRoundedIcon />}
            aria-label="Logout"
          >
            <span className="app-topnav-logout-text">Logout</span>
          </Button>
        </div>
      </div>
    </div>
  );
}
